var _circle, _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBrowserLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    stroke: "#80829D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5C10.5 9.51485 10.1179 11.3146 9.52178 12.5919C8.90677 13.9097 8.15685 14.5 7.5 14.5C6.84315 14.5 6.09323 13.9097 5.47822 12.5919C4.88215 11.3146 4.5 9.51485 4.5 7.5C4.5 5.48515 4.88215 3.68543 5.47822 2.40814C6.09323 1.09025 6.84315 0.5 7.5 0.5C8.15685 0.5 8.90677 1.09025 9.52178 2.40814C10.1179 3.68543 10.5 5.48515 10.5 7.5Z",
    stroke: "#80829D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 5,
    x2: 14,
    y2: 5,
    stroke: "#80829D"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 10,
    x2: 14,
    y2: 10,
    stroke: "#80829D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBrowserLight);
export default __webpack_public_path__ + "static/media/icn-browser-light.c3349442739a8d44a665e93881c2b0b6.svg";
export { ForwardRef as ReactComponent };